import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import '../styles/Civilhero.css';


import serviceVideo from '../assets/cv-bg-vid.mp4';
import img1 from '../assets/building.jpg';
import img2 from '../assets/cg4.jpg';
import img3 from '../assets/cg1.jpg';
import img4 from '../assets/cg2.jpg';
 
import img5 from '../assets/cg3.jpg';
const Civilpg = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
     <div className="servicepg-container">
      <video className="background-video" autoPlay muted loop playsInline>
        <source src={serviceVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="servicepg-content">
        <motion.div
          className="servicepg-left"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <h1>CIVIL SERVICES</h1>
          <p>
            We offer comprehensive civil engineering solutions including site development,
            structural drafting, and construction planning — tailored for infrastructure,
            residential, and commercial projects.
          </p>
        </motion.div>

        <motion.div
          className="servicepg-right"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <div className="image-merge-container">
            <img className="merged-img img1" src={img1} alt="Civil 1" />
            <img className="merged-img img2" src={img2} alt="Civil 2" />
            <img className="merged-img img3" src={img3} alt="Civil 3" />
            <img className="merged-img img4" src={img4} alt="Civil 4" />
            <img className="merged-img img5" src={img5} alt="Civil 5" />
          </div>
        </motion.div>
      </div>
    </div>
    </>
   
  );
};

export default Civilpg;
